import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image } from '../Image/Image';
import styles from './styles';
export const GreetingCard = ({ greeting, imageName, selectedDateRange }) => {
    const { t: text } = useTranslation();
    const imagePath = `/assets/images/${imageName}.svg`;
    // Need to adjust image width when using evening icon
    const imageWidth = imageName === 'evening-icon' ? 30 : 22;
    // Need to recenter image when using evening icon
    const imageTransform = imageName === 'evening-icon' ? [0.5, 1.5] : [0, 0];
    const dynamicDateGreeting = (selectedDateRange) => {
        switch (selectedDateRange) {
            case 'weekly':
                return text('GREETING_SUBTITLE_WEEK');
            case 'monthly':
                return text('GREETING_SUBTITLE_MONTH');
            case 'quaterly':
                return text('GREETING_SUBTITLE_QUARTER');
            case 'yearly':
                return text('GREETING_SUBTITLE_YEAR');
            default:
                return text('GREETING_SUBTITLE_WEEK');
        }
    };
    return (_jsx(Box, { sx: styles.greetingBG, children: _jsxs(Grid, { item: true, container: true, flexWrap: 'nowrap', p: 5, columnGap: 1, sx: {
                paddingX: { mobile: '24px', desktop: '80px' },
                paddingY: { mobile: '24px', desktop: '40px' },
            }, children: [_jsx(Grid, { item: true, sx: styles.icon, children: _jsx(Image, { src: imagePath, width: imageWidth, transform: imageTransform, altTextKey: 'empty' }) }), _jsx(Grid, { item: true, container: true, direction: 'column', children: _jsxs(Grid, { item: true, children: [_jsx(Typography, { variant: 'h1', mb: 1, sx: {
                                    marginTop: { mobile: '9px', desktop: '7px' },
                                    fontSize: { mobile: '24px', desktop: '28px' },
                                }, children: greeting || '' }), _jsx(Typography, { variant: 'subtitle2', sx: { fontSize: { mobile: '14px', desktop: '18px' } }, children: dynamicDateGreeting(selectedDateRange) })] }) }), _jsx(Grid, { item: true, height: '150px' })] }) }));
};
